export function singleFag_ShowMore(){
    let container = document.querySelector('.main__content__show-more');

    if(!container){
        return
    }

    let container_height = container.scrollHeight,
        container_btn = document.querySelector('.main__content__show-more + button')


    if(container_height < 250){
        container.classList.add('all')
        container_btn.remove()
    }

    container_btn.addEventListener('click', () => {
        container.classList.add('all')
        container_btn.classList.add('btn-hidden')
        container_btn.remove();
        container.style.height = container_height + 'px'
    })
}

export function singleFag_setHeightOfBlockQoute(){
    let page_type = document.querySelector('body').classList.contains('single-fag', 'single-');

    if(!page_type){
        return
    }

    let blockqoutes = document.querySelectorAll('blockquote');

    blockqoutes.forEach((blockqoute) => {
       let height = blockqoute.offsetHeight + 72;
       blockqoute.style.height = height + 'px';
    });
}